const comparisonRows = [
  {
    apps: "Logs your workout",
    edith: "Notices you skipped",
  },
  {
    apps: "Sends generic reminders",
    edith: "Calls you out personally",
  },
  {
    apps: "Silent when you fail",
    edith: "Gets in your face",
  },
  {
    apps: "Data dashboards",
    edith: "Real accountability",
  },
  {
    apps: "You motivate yourself",
    edith: "EDITH pushes you",
  },
];

export default function TheDifference() {
  return (
    <section id="the-difference" className="nm-section-dark reveal-section" data-reveal data-testid="the-difference-section">
      <div className="nm-container py-12 md:py-14">
        <span className="nm-eyebrow inline-block text-black/50">
          The Difference
        </span>
        <div className="mb-6 md:mb-8 text-center">
          <h2 className="mt-3 text-[clamp(1.45rem,2.7vw,2.15rem)] text-black leading-[0.98]">
            Other Fitness Apps <span className="text-black/45">Vs </span><span className="text-black">EDITH.</span>
          </h2>
        </div>

        <div className="max-w-3xl rounded-xl border border-black bg-white px-2.5 md:px-3.5 mx-auto overflow-hidden">
          <div className="grid grid-cols-2 divide-x divide-white border-b border-black py-2.5 text-[clamp(0.88rem,1.15vw,1.1rem)] leading-none bg-black text-white -mx-2.5 md:-mx-3.5">
            <h3 className="font-semibold text-center px-2">Other Fitness Apps</h3>
            <h3 className="font-semibold text-center px-2">EDITH</h3>
          </div>

          {comparisonRows.map((row, index) => (
            <div
              key={row.apps}
              className={`grid grid-cols-2 items-center divide-x divide-black py-2.5 md:py-3 text-[clamp(0.82rem,1vw,0.98rem)] leading-tight text-black ${
                index < comparisonRows.length - 1 ? "border-b border-black" : ""
              }`}
              data-testid={`comparison-row-${index}`}
            >
              <p className="px-2 text-black text-center font-medium">{row.apps}</p>
              <p className="px-2 text-black text-center font-medium">{row.edith}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 max-w-3xl mx-auto text-center">
          <p className="text-[clamp(1rem,1.3vw,1.2rem)] leading-none text-black font-bold">
            Other apps track. <span className="text-black">EDITH acts.</span>
          </p>
          <p className="mt-2.5 text-[clamp(0.9rem,1.1vw,1rem)] leading-tight text-black/70 font-medium">
            Tracking isn't accountability.
          </p>
        </div>
      </div>
    </section>
  );
}
